import React, { useState, useEffect } from 'react';
import moment from 'moment';
import { SearchOutlined, ClearOutlined } from '@ant-design/icons';
import {
	Spin,
	Table,
	Tag,
	Row,
	Col,
	Drawer,
	Input,
	Button,
	Space,
	DatePicker,
	Select,
	message,
	Form
} from 'antd';
import { delay } from '../../helpers/helpers';
import cookies from 'js-cookie';
import axiosConfig from '../../utils/axios-config';
import { useSelector } from 'react-redux';
import './main-logging-table.scss';
import { withRouter, useHistory, Link } from 'react-router-dom';

const MainLoggingTable = () => {

	const [form] = Form.useForm();

	let history = useHistory();
	const [messageApi, contextHolder] = message.useMessage();
	const [filterParams, setFilterParams] = useState({});
	const [customers, setCustomers] = useState([]);
	const [companies, setCompanies] = useState([]);
	const [processDisable, setProcessDisable] = useState(true);
	const [processes, setProcesses] = useState([]);
	const [filteredData, setFilteredData] = useState([]);
	const [tableData, setTableData] = useState([]);
	const [loading, setLoading] = useState(false);
	const [visible, setVisible] = useState(false);
	const [currentEntry, setCurrentEntry] = useState('');
	const [currentEntryTitle, setCurrentEntryTitle] = useState('Comments');
	const [searchCriteria, setSearchCriteria] = useState({});
	const currentUser = useSelector((state) => state.auth.currentUser);
	const { RangePicker } = DatePicker;

	const onFinish = async (values) => {
		// This function will be called when the form is submitted
		// The 'values' object will contain all the form field data
		let formStr = JSON.stringify(values);

		fetchQueryTable(values);
		console.log('Form values:', formStr);
	};

	const handleClear = () => {
		// This function clears all form fields
		form.resetFields();
	};

	useEffect(() => {
		let isMounted = true;
		if (currentUser && currentUser.id && isMounted) {
			fetchCustomers();
			fetchCompanies();
			fetchTable();
		}
		return () => {
			isMounted = false;
		};
	}, []);

	useEffect(() => {
		applySearchCriteria();
	}, [searchCriteria]);

	const applySearchCriteria = () => {
		let filterData = tableData;
		if (searchCriteria.keyword && searchCriteria.keyword.length >= 3) {
			filterData = filterData.filter(
				(row) =>
					(row.companyName &&
						row.companyName
							.toLowerCase()
							.indexOf(searchCriteria.keyword.toLowerCase()) >
						-1) ||
					(row.id &&
						row.id
							.toString()
							.toLowerCase()
							.indexOf(searchCriteria.keyword.toLowerCase()) >
						-1) ||
					(row.projectName &&
						row.projectName
							.toLowerCase()
							.indexOf(searchCriteria.keyword.toLowerCase()) >
						-1) ||
					(row.processName &&
						row.processName
							.toLowerCase()
							.indexOf(searchCriteria.keyword.toLowerCase()) >
						-1) ||
					(row.startComments &&
						row.startComments
							.toLowerCase()
							.indexOf(searchCriteria.keyword.toLowerCase()) >
						-1) ||
					(row.endComments &&
						row.endComments
							.toLowerCase()
							.indexOf(searchCriteria.keyword.toLowerCase()) >
						-1)
			);
			setFilteredData(filterData);
		}
		setFilteredData(filterData);
	};

	const filterByKeyword = (e) => {
		delay(function () {
			setSearchCriteria({ ...searchCriteria, keyword: e.target.value });
		}, 500);
	};

	const techStatusOptions = [
		{
			value: "1",
			label: "No Status"
		},
		{
			value: "2",
			label: "Successful"
		},
		{
			value: "3",
			label: "No Status"
		},
		{
			value: "4",
			label: "Failed"
		}
	];

	const businessStatusOptions = [
		{
			value: "1",
			label: "No Status"
		},
		{
			value: "2",
			label: "Successful"
		},
		{
			value: "3",
			label: "No Status"
		},
		{
			value: "4",
			label: "Failed"
		}
	];

	const fetchCompanies = async () => {
		await axiosConfig({
			method: 'get',
			url: `/api/rpa/main-loggings/companies`,
			headers: {
				Authorization: `Bearer ${cookies.get('access_token')}`,
			},
		})
			.then((response) => {
				console.log("Company Data", response);
				let companyList = response.data.data;
				let newCompanies = companyList.map((c) => {
					return { value: c.id, label: c.name };
				});
				setCompanies(newCompanies);
			})
			.catch((error) => {
				if (error.response) {
					// The request was made and the server responded with a status code
					// that falls out of the range of 2xx
					console.log(error.response.data);
					console.log(error.response.status);
					console.log(error.response.headers);
				} else if (error.request) {
					// The request was made but no response was received
					// `error.request` is an instance of XMLHttpRequest in the browser and an instance of
					// http.ClientRequest in node.js
					console.log(error.request);
				} else {
					// Something happened in setting up the request that triggered an Error
					console.log('Error', error.message);
				}
				console.log(error.config);
			});
	};

	const fetchTable = async () => {

		try {
			setLoading(true);
			await axiosConfig({
				method: 'get',
				url: `/api/rpa/main-loggings/today`,
				headers: {
					Authorization: `Bearer ${cookies.get('access_token')}`,
				},
			})
				.then((response) => {
					console.log('Table Data', response);
					const data = response.data.data.map((res, index) => {
						index++;
						return {
							key: res.id,
							id: res.id,
							no: res.id,
							companyName: res.company?.name,
							departmentName: res.department?.name,
							processName: res.processName,
							initiatedBy: res.initiatedBy,
							techStatus: res.techStatus,
							businessStatus: res.businessStatus,
							oSUserName: res.oSUserName,
							userName: res.userName,
							startComments: res.startComments,
							endComments: res.endComments,
							startTime: res.startTime,
							endTime: res.endTime,
						};
					});
					setTableData(data);
					setFilteredData(data);
					setLoading(false);
				})
				.catch((error) => {
					if (error.response) {
						// The request was made and the server responded with a status code
						// that falls out of the range of 2xx
						console.log(error.response.data);
						console.log(error.response.status);
						console.log(error.response.headers);
					} else if (error.request) {
						// The request was made but no response was received
						// `error.request` is an instance of XMLHttpRequest in the browser and an instance of
						// http.ClientRequest in node.js
						console.log(error.request);
					} else {
						// Something happened in setting up the request that triggered an Error
						console.log('Error', error.message);
					}
					setLoading(false);
					console.log(error.config);
				})
		}
		catch (error) {

		}
		finally {
			setLoading(false);
		}

	};

	const fetchQueryTable = async (request) => {

		try {

			setLoading(true);
			await axiosConfig({
				method: 'post',
				data: request,
				url: `/api/rpa/main-loggings/query`,
				headers: {
					Authorization: `Bearer ${cookies.get('access_token')}`,
				},
			})
				.then((response) => {
					const data = response.data.data.map((res, index) => {
						index++;
						return {
							key: res.id,
							id: res.id,
							no: res.id,
							companyName: res.company?.name,
							departmentName: res.department?.name,
							processName: res.processName,
							initiatedBy: res.initiatedBy,
							techStatus: res.techStatus,
							businessStatus: res.businessStatus,
							oSUserName: res.oSUserName,
							userName: res.userName,
							startComments: res.startComments,
							endComments: res.endComments,
							startTime: res.startTime,
							endTime: res.endTime,
						};
					});
					console.log('Table Data', data);
					setTableData(data);
					setFilteredData(data);
					setLoading(false);
				})
				.catch((error) => {
					if (error.response) {
						// The request was made and the server responded with a status code
						// that falls out of the range of 2xx
						console.log(error.response.data);
						console.log(error.response.status);
						console.log(error.response.headers);
					} else if (error.request) {
						// The request was made but no response was received
						// `error.request` is an instance of XMLHttpRequest in the browser and an instance of
						// http.ClientRequest in node.js
						console.log(error.request);
					} else {
						// Something happened in setting up the request that triggered an Error
						console.log('Error', error.message);
					}
					setLoading(false);
					console.log(error.config);
				});
		}
		catch (error) {

		}
		finally {
			setLoading(false);
		}


	};

	const fetchCustomers = async () => {
		await axiosConfig({
			method: 'get',
			url: `/api/roxuslogging/logging-customers`,
			headers: {
				Authorization: `Bearer ${cookies.get('access_token')}`,
			},
		})
			.then((response) => {
				console.log(response);
				let customerList = response.data;
				let newCustomers = customerList.map((c) => {
					return { value: c, label: c };
				});
				setCustomers(newCustomers);
			})
			.catch((error) => {
				if (error.response) {
					// The request was made and the server responded with a status code
					// that falls out of the range of 2xx
					console.log(error.response.data);
					console.log(error.response.status);
					console.log(error.response.headers);
				} else if (error.request) {
					// The request was made but no response was received
					// `error.request` is an instance of XMLHttpRequest in the browser and an instance of
					// http.ClientRequest in node.js
					console.log(error.request);
				} else {
					// Something happened in setting up the request that triggered an Error
					console.log('Error', error.message);
				}
				setLoading(false);
				console.log(error.config);
			});
	};

	const fetchProcessesByCompany = async (request) => {

		var companyId = request.companyName;

		if (companyId) {
			await axiosConfig({
				method: 'get',
				url: `/api/rpa/main-loggings/companies/${companyId}/processNames`,
				data: request,
				headers: {
					Authorization: `Bearer ${cookies.get('access_token')}`,
				},
			})
				.then((response) => {
					console.log(response);
					let processList = response.data.data;
					let newProcesses = processList.map((p) => {
						if (p) {
							return { value: p, label: p };
						}
					});
					if (newProcesses.length > 0) {
						setProcesses(newProcesses);
						setProcessDisable(false);
					}
					else {
						setProcesses([]);
						setProcessDisable(true);
					}

				})
				.catch((error) => {
					if (error.response) {
						// The request was made and the server responded with a status code
						// that falls out of the range of 2xx
						console.log(error.response.data);
						console.log(error.response.status);
						console.log(error.response.headers);
					} else if (error.request) {
						// The request was made but no response was received
						// `error.request` is an instance of XMLHttpRequest in the browser and an instance of
						// http.ClientRequest in node.js
						console.log(error.request);
					} else {
						// Something happened in setting up the request that triggered an Error
						console.log('Error', error.message);
					}
					setLoading(false);
					console.log(error.config);
				});
		}

	};

	const changePage = (page, logId) => {
		switch (page) {
			case 'main-logging':
				window.open(`/rpa/main-logging/${logId}`, '_blank');
				break;
			default:
				break;
		}
	};

	function isJsonString(str) {
		try {
			JSON.parse(str);
		} catch (e) {
			return false;
		}
		return true;
	}

	const renderCommentPreview = (text, title) => {
		const commentText = typeof text === 'string' ? text.trim() : '';
		const previewLength = 28;

		if (!commentText) {
			return '-';
		}

		if (commentText.length > previewLength) {
			return (
				<div className="logging-table-comment-preview">
					<span className="logging-table-comment-preview__text">
						{commentText.substring(0, previewLength)}...
					</span>
					<Button
						type="link"
						size="small"
						className="logging-table-comment__toggle"
						onClick={() => {
							setCurrentEntry(commentText);
							setCurrentEntryTitle(title);
							setVisible(true);
						}}
					>
						More
					</Button>
				</div>
			);
		}

		return <span className="logging-table-comment__inline">{commentText}</span>;
	};

	const columns = [
		{
			title: 'Action',
			key: 'action',
			dataIndex: 'action',
			width: 110,
			render: (text, record) => {
				return (
					<>
						<Button
							onClick={() =>
								changePage('main-logging', record.key)
							}
						>
							View Log
						</Button>
					</>
				);
			},
		},
		{
			title: 'Id',
			dataIndex: 'id',
			key: 'id',
			width: 90,
		},
		{
			title: 'Start Time',
			key: 'startTime',
			dataIndex: 'startTime',
			width: 170,
			render: (text) => {
				const dateObject = moment(text);
				const formattedDate = dateObject.format("YYYY-MM-DD HH:mm:ss");
				return formattedDate;
			}

		},
		{
			title: 'End Time',
			key: 'endTime',
			dataIndex: 'endTime',
			width: 170,
			render: (text) => {
				if (text) {
					const dateObject = moment(text);
					const formattedDate = dateObject.format("YYYY-MM-DD HH:mm:ss");
					return formattedDate;
				}
			}
		},
		{
			title: 'Company Name',
			dataIndex: 'companyName',
			key: 'companyName',
		},
		{
			title: 'Department Name',
			dataIndex: 'departmentName',
			key: 'departmentName',
		},
		{
			title: 'Process Name',
			dataIndex: 'processName',
			key: 'processName',
		},
		{
			title: 'Initiated By',
			dataIndex: 'initiatedBy',
			key: 'initiatedBy',
		},
		{
			title: 'Tech Status',
			key: 'techStatus',
			dataIndex: 'techStatus',
			width: 150,
			render: (text) => {
				if (text == "1") {
					return <Tag color="default">No Status</Tag>;
				}
				else if (text == "2") {
					return <Tag color="success">Successful</Tag>;
				}
				else if (text == "3") {
					return <Tag color="error">Unsuccessful</Tag>;
				}
				else if (text == "4") {
					return <Tag color="error">Failed</Tag>;
				}
				else {
					return <Tag color="default">No Status</Tag>;
				}
			},
		},
		{
			title: 'Business Status',
			key: 'businessStatus',
			dataIndex: 'businessStatus',
			width: 160,
			render: (text) => {
				if (text == "1") {
					return <Tag color="default">No Status</Tag>;
				}
				else if (text == "2") {
					return <Tag color="success">Successful</Tag>;
				}
				else if (text == "3") {
					return <Tag color="error">Unsuccessful</Tag>;
				}
				else if (text == "4") {
					return <Tag color="error">Failed</Tag>;
				}
				else {
					return <Tag color="default">No Status</Tag>;
				}
			},
		},
		// {
		// 	title: 'OS Username',
		// 	key: 'oSUserName',
		// 	dataIndex: 'oSUserName',
		// },
		// {
		// 	title: 'Username',
		// 	key: 'userName',
		// 	dataIndex: 'userName',
		// },
		{
			title: 'Start Comments',
			key: 'startComments',
			dataIndex: 'startComments',
			className: 'logging-table-comments-column',
			onHeaderCell: () => ({
				style: {
					minWidth: '180px',
					maxWidth: '240px',
				},
			}),
			onCell: () => ({
				style: {
					minWidth: '180px',
					maxWidth: '240px',
				},
			}),
			render: (text) => renderCommentPreview(text, 'Start Comments'),
		},
		{
			title: 'End Comments',
			key: 'endComments',
			dataIndex: 'endComments',
			className: 'logging-table-comments-column',
			onHeaderCell: () => ({
				style: {
					minWidth: '180px',
					maxWidth: '240px',
				},
			}),
			onCell: () => ({
				style: {
					minWidth: '180px',
					maxWidth: '240px',
				},
			}),
			render: (text) => renderCommentPreview(text, 'End Comments'),
		}
	];

	const onCompanyChange = async (value) => {
		console.log(`selected ${value}`);
		setFilterParams({ ...filterParams, companyName: value });
		if (value) {
			let processRequest = { companyName: value };
			await fetchProcessesByCompany(processRequest);
		} else {
			setProcessDisable(true);
		}
	};

	const onProcessChange = (value) => {
		console.log(`selected ${value}`);
		setFilterParams({ ...filterParams, processName: value });
	};

	const filterProcesses = async () => {

		console.log('Filter Params', filterParams);

		await fetchQueryTable(filterParams);

	};


	// Filter `option.label` match the user type `input`
	const filterOption = (input, option) =>
		(option?.label ?? '').toLowerCase().includes(input.toLowerCase());

	return (
		<>
			{contextHolder}
			<Spin spinning={loading}>
				<Form
					form={form}
					name="search-form"
					onFinish={onFinish}
				>
					<Row gutter={[16, 16]} align="middle">
						
						<Col xs={24} lg={16}>

							<Space size="small" wrap>

								<Form.Item name="company" style={{ marginBottom: 0 }}>
									<Select
										showSearch
										placeholder='Select Company'
										optionFilterProp='children'
										filterOption={(input, option) => (option?.children ?? '').toLowerCase().includes(input.toLowerCase())}
										style={{ width: 220 }}
										options={companies}
										onChange={onCompanyChange}
										allowClear
									/>
								</Form.Item>

								<Form.Item name="process" style={{ marginBottom: 0 }}>
									<Select
										showSearch
										placeholder='Select Process'
										optionFilterProp='children'
										filterOption={(input, option) => (option?.children ?? '').toLowerCase().includes(input.toLowerCase())}
										style={{ width: 220 }}
										options={processes}
										onChange={onProcessChange}
										allowClear
									/>
								</Form.Item>

								<Form.Item name="techStatus" style={{ marginBottom: 0 }}>
									<Select
										showSearch
										placeholder='Select Tech Status'
										optionFilterProp='children'
										filterOption={(input, option) => (option?.children ?? '').toLowerCase().includes(input.toLowerCase())}
										style={{ width: 150 }}
										options={techStatusOptions}
										allowClear
									/>
								</Form.Item>

								<Form.Item name="businessStatus" style={{ marginBottom: 0 }}>
									<Select
										showSearch
										placeholder='Select Business Status'
										optionFilterProp='children'
										filterOption={(input, option) => (option?.children ?? '').toLowerCase().includes(input.toLowerCase())}
										style={{ width: 150 }}
										options={businessStatusOptions}
										allowClear
									/>
								</Form.Item>

								<Form.Item name="dateRange" style={{ marginBottom: 0 }}>
									<RangePicker
										placeholder={['From Date', 'To Date']}
										style={{ width: 220 }}
									/>
								</Form.Item>

								<Form.Item style={{ marginBottom: 0 }}>
									<Button type='primary' htmlType='submit' size="small" icon={<SearchOutlined />}>
										Search
									</Button>
								</Form.Item>

								<Form.Item style={{ marginBottom: 0 }}>
									<Button onClick={handleClear} size="small" icon={<ClearOutlined />}>
										Clear
									</Button>
								</Form.Item>

							</Space>

						</Col>

						{/* Keyword Search Column */}
						<Col xs={24} lg={8}>
							<Input
								id='search-box'
								onKeyUp={filterByKeyword}
								addonBefore={<SearchOutlined />}
								placeholder='Search'
							/>
						</Col>
					</Row>
				</Form>
				<Table loading={loading} columns={columns} scroll={{ x: 1400 }} dataSource={filteredData} />
				<Drawer
					title={currentEntryTitle}
					placement='bottom'
					closable={true}
					onClose={() => setVisible(false)}
					visible={visible}
					height="50vh"
					destroyOnClose={true}
				>
					<div className="logging-table-comment-drawer">
						<div className="logging-table-comment-drawer__content">
							{currentEntry}
						</div>
					</div>
				</Drawer>
			</Spin>
		</>
	);
};

export default MainLoggingTable;
